export default {
	name: "complete-exTank-order",
	props:{
		orderExTankId: {
			default: null
		},
		orderId:{
			default: null
		}
	},
	data() {
		return {
			order: {},
			orderGrandTotal: 0,
			billingAddress:null,
			shippingAddress: null,
			reasonsForDeliveryFailure: [],
			deliveryProcessFeatureFlags: {},
			totalForOrder: 0,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			bolLoadingDate:{
				value: null,
				errorMessage: null,
				hasError: false,
				initialiseDate: true
			},
			orderItemsHasError: false,
			orderItemsErrorMessage: null,
			orderItemsHeadings: [
				{
					text: "Product",
					field: "product"
				},
				{
					text: "Price",
					field: "priceAsString"
				},
				{
					text: "Quantity/Litres",
					field: "quantity"
				},
				{
					text: "Amount Dispensed",
					field: "quantityDispensed"
				},
				{
					text: "Total",
					field: "totalAsString"
				},
				// {
				// 	text: "Total Price Dispensed",
				// 	field: "totalDispensedAsString"
				// }
			],
			trackingHistoryModal:{
				showModal: false,
				isSaving: false,
				modalId: "trackingHistoryModal",
				heading: "Tracking History",
				orderId: null
			},
			orderItemsDispensed: {
				value: [],
				errorMessage: null,
				hasError: false
			},
			cancelOrderModalId: "cancelOrderModal",
			markAsOnDeliveryModalId: "markAsOnDeliveryModal",
			cancelOrderScheduledForDeliveryModalId: "cancelOrderScheduledForDeliveryModal",
			completeOrderConfirmationModalId: "completeOrderConfirmationModal",
			orderStatus: {},
			actions: [],
			actionKeys:{
				edit: "edit",
				delete: "delete"
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			loadingBillingAddress: false,
			selectedHeartbeatStatusCodeId: null,
			successModal:{
				modalHeading: "Success",
				modalMessage: null,
				elementId: "reviewOrderSuccessModal",
				showModal: false
			},
			orderTypeId: null
		};
	},
	methods: {
		getExTankOrder(){
			this.loading = true;
			exTankService.getExTankOrder(this.orderExTankId).then(
				successResponse =>{
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.order = successResponse.data.result;
						this.order = dataTableHelper.castObjectValues(this.order);
						this.order.totalAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.order.totalAmount);
						this.orderGrandTotal = this.order.totalAmount;
						if(this.order.discountedAmount !== null && this.order.discountedAmount > 0) {
							this.orderGrandTotal = this.order.totalAmount - this.order.discountedAmount;
						}
						this.orderGrandTotal = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderGrandTotal);

						console.log("order", this.order);
						this.setBreadcrumbs();
						this.getCustomerBillingAddress();
					}
					this.loading = false;
					// setTimeout(function (){
					// 	var btnViewOrderCancel = document.getElementById("btnViewOrderCancel");
					// 	var btnViewOrderDownload = document.getElementById("btnViewOrderDownload");
					// 	var btnViewOrderViewTrackingHistory = document.getElementById("btnViewOrderDownload");
					// 	var viewOrderActions = document.getElementById("viewOrderActions");
					// 	if(btnViewOrderCancel.classList.contains("hide-element") &&
					// 		btnViewOrderDownload.classList.contains("hide-element") &&
					// 		btnViewOrderViewTrackingHistory.classList.contains("hide-element")){
					// 		viewOrderActions.classList.add("hide-element");
					// 	}
					// }, 100)

				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerBillingAddress(){
			this.loadingBillingAddress = true;
			customerService.getCompanyAddress(this.order.billingAddressId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.billingAddress = successResponse.data.result;
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		downloadBol(){
			exTankService.downloadExTankDocument(this.order.orderId, orderHelper.documentType.bol);
		},
		onBolLoadingDateChange(date){
			this.bolLoadingDate.value = date;
			this.bolLoadingDate.initialiseDate = false;
		},
		onDispenseUpdate(orderItems){
			this.orderItemsDispensed.value = orderItems;
			console.log("orderItemsDispensed", this.orderItemsDispensed);
		},
		onSuccessModalOkClick(){
			this.successModal.showModal = false;
			this.$router.go(-1);
		},
        markAsPendingInvoice(){
            this.loading = true;
            let request = {
                orderId: this.order.orderId,
                orderDispensedItems: this.orderItemsDispensed.value,
                bolLoadedDate: this.bolLoadingDate.value,
                companyId: this.order.companyId
            };
            exTankService.markOrderAsInPendingInvoice(request).then(
                successResponse => {
                    let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
                    console.log("successResponse", successResponse);
                    if(isSuccess){
                        if(successResponse.data.validationResponse.valuesAreValid){
                            this.successModal.modalMessage = "Order marked as pending invoice successfully";
                            this.successModal.showModal = true;
                            console.log("successModal", this.successModal);
                        }
                        else{
                            this.bolLoadingDate.hasError = successResponse.data.validationResponse.bolLoadingDateValidationResponse.hasError;
                            this.bolLoadingDate.errorMessage = successResponse.data.validationResponse.bolLoadingDateValidationResponse.message;

                            this.orderItemsDispensed.hasError = successResponse.data.validationResponse.orderItemsDispensedValidationResponse.hasError;
                            this.orderItemsDispensed.errorMessage = successResponse.data.validationResponse.orderItemsDispensedValidationResponse.message;
                        }
                    }
                    this.loading = false;
                },
                errorResponse => {
                    console.log("error", errorResponse);
                    this.loading = false;
                    apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
                }
            );
        },
		completeOrder(){
			this.loading = true;
			let request = {
				orderId: this.order.orderId,
				orderDispensedItems: this.orderItemsDispensed.value,
				bolLoadedDate: this.bolLoadingDate.value,
				companyId: this.order.companyId
			};
			exTankService.completeExTankOrder(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					console.log("successResponse", successResponse);
					if(isSuccess){
						if(successResponse.data.validationResponse.valuesAreValid){
							this.successModal.modalMessage = "Order completed successfully";
							this.successModal.showModal = true;
							console.log("successModal", this.successModal);
						}
						else{
							this.bolLoadingDate.hasError = successResponse.data.validationResponse.bolLoadingDateValidationResponse.hasError;
							this.bolLoadingDate.errorMessage = successResponse.data.validationResponse.bolLoadingDateValidationResponse.message;
							
							this.orderItemsDispensed.hasError = successResponse.data.validationResponse.orderItemsDispensedValidationResponse.hasError;
							this.orderItemsDispensed.errorMessage = successResponse.data.validationResponse.orderItemsDispensedValidationResponse.message;
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		setBreadcrumbs() {
			var pageTitle = "Complete Ex-Tank Order - #" + this.order.orderId + " (" + this.order.registeredCompanyName + ")";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.orderStatus = orderHelper.orderStatus;
		this.orderTypeId = orderHelper.orderType.exTank;
	},
	watch:{
		orderExTankId:{
			handler: function () {
				if (this.orderExTankId !== null && this.orderExTankId > 0) {
					this.getExTankOrder();
				}
			},
			immediate: true,
			deep: true
		}
	}
};